import { TextBox } from '@apply/components';
import { useCustomPaymentPropertyLoanReference } from '../../../../../fields/CustomPaymentFields';

interface PropertyOrLoanIdentifierProps {
    customPaymentId: string;
    validator?: React.ReactNode;
}

export const PropertyOrLoanIdentifier: React.FC<PropertyOrLoanIdentifierProps> = ({ customPaymentId, validator }) => {
    const label = 'Which Property / Loan ';
    const [propertyLoanReference, set_propertyLoanReference] = useCustomPaymentPropertyLoanReference(customPaymentId);

    return (
        <>
            <TextBox
                id='propertyOrLoanIdentifier'
                value={propertyLoanReference}
                onChange={(value) => set_propertyLoanReference(value)}
                label={label}
                required={true}
                width='100%'
                maxLength={150}
                validator={validator}
                placeholder='e.g. property address'
            />
        </>
    );
};
